import Axios from 'axios';

export default {
  async uploadFile(file) {
    const fileName = file.name;
    const signedUrl = await Axios.get(`/media/${fileName}`, { params: { contentType: file.type } }).then(
      (response) => response.signedUrl
    );
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', signedUrl, true);
      xhr.setRequestHeader('Content-Type', file.type);
      xhr.onload = () => {
        if (xhr.status === 200) {
          resolve(signedUrl.split('?')[0]);
        }
      };
      xhr.onerror = (e) => {
        reject(e);
      };
      xhr.send(file);
    });
  },
};
